import React, { useEffect } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'
import { setMfaOperationData } from 'alelo-logic/services/common/storage'

import { Container } from './styles'

const ForgotPassword = props => {
  document.title = 'Minha Veloe | Esqueci senha'
  const vsgSdk = useVsgSdk()

  useEffect(() => {
    const forgotPasswordComponent = vsgSdk.renderizarEsqueciSenha({
      background: '/images/wronguser.png',
      showCnpj: false,
      loginType: 'cpf',
      title: 'Relaxa! Isso acontece com todo mundo.',
      subtitle:
        'E você pode contar conosco para te ajudar. Você precisa informar os seus dados de acesso abaixo:',
      validationLinkMessage: 'Caso não tenha recebido, clique no botão "Reenviar e-mail".'
    })

    forgotPasswordComponent.on('cancelar', () => {
      props.history.push('/conta/login')
    })

    forgotPasswordComponent.on('mfa', ({ operationToken, resource }) => {
      if (!operationToken || !resource) return

      const successUrl = `/conta/criar-senha?token=${operationToken}`
      setMfaOperationData({ operationToken, resource, successUrl })
      props.history.push('/conta/mfa')
    })

    forgotPasswordComponent.on('erro', apiResponse => {
      console.error('Erro no esqueci senha:', apiResponse)
    })
  }, [vsgSdk])

  return <Container id="vsg-esqueci-senha" data-testid="vsg-esqueci-senha" />
}

export default ForgotPassword
